import "./css/Dashboard.css"
import Navigation from "../components/Navigation"
import { Outlet } from "react-router"
import { createContext, useState, useEffect } from "react"
import axios from "axios"
import api from "../config/backend"
import Header from "../components/Header"

export const DashboardState = createContext()

const Dashboard = () => {
    const [isHeaderVisible, setIsHeaderVisible] = useState(true)
    const [outletLoading, setOutletLoading] = useState(false)
    const [triggerRefresh, setTriggerRefresh] = useState(0)

    const value = {
        state: { isHeaderVisible, outletLoading },
        actions: { setIsHeaderVisible, setOutletLoading }
    }

    const token = localStorage.getItem("token")
    const domain = localStorage.getItem("domain")
    const _crm__token = localStorage.getItem("_crm__token")
    const endpoint = localStorage.getItem("startpoint")

    const onboardVibho = async () => {
        let authtoken
        console.log(token)
        if (token === null) {
            console.log({ token, "error": "couldn't find token in local storage" })
            return
        }

        if (token.includes("Bearer")) {
            authtoken = token.split(" ")[1]
        }
        else {
            authtoken = token
        }

        setOutletLoading(true)
        const { data, status } = await axios.post(`${api}/Author/onboard-vibho`, { token: authtoken, endpoint, domain })

        setOutletLoading(false)

        if (data.success) {
            localStorage.setItem("_crm__token", data.token)
            setTriggerRefresh(prev => prev + 1)
        } else {
            console.log({ data })
        }
    }

    // Onboard or login vibho users
    useEffect(() => {
        if (_crm__token === null) {
            onboardVibho()
        }
    }, [_crm__token])

    return (
        <DashboardState.Provider value={value}>
            <div className="_6sls">
                <Navigation />
                <div>
                    <Header />
                    <Outlet key={triggerRefresh} />
                </div>
            </div>
        </DashboardState.Provider>
    )
}

export default Dashboard
